import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const TemplateRequestManagerStyled = styled.div`
  .title-container {
    padding: 30px 60px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;

    /* Sin filtros aplicados el contenedor de chips queda vacío: que no sume otro hueco */
    > div:empty {
      display: none;
    }

    label {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
      margin-right: 20px;
      min-width: 200px;
    }
    input {
      font-size: 14px;
      font-family: 'Poppins';
    }

    & h2 {
      font-size: 20px; /* título de página de Velora (CommonHeaderGroup) */
      font-weight: 600;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      color: ${tokens.color.text.tertiary};
      font-weight: 400;
      margin-bottom: 0;
    }

    & p {
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
    }
  }

  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 0; /* el toggle va pegado a la descripción, sin hueco extra */

    h5 {
      margin-bottom: 0px;
    }
  }

  .containerButtons {
    display: inline-flex;
    align-items: center;
    align-self: end;
    justify-content: flex-end;
    gap: 10px;
    background-color: ${tokens.color.background.light};
    padding: 8px 10px;
    border-radius: 50px;
  }
`
